import React from 'react'
import DateFormatView from './DateFormatView'

export default function UpdateHistoryTrack(props) {
  const { version_attributes, ChangedValuesDetails, wrapperClasses } = props

  const RenderVersionDetails = ({ version }) => {
    return (
      <>
        <div className="d-flex align-items-center flex-wrap mb-2" style={{ gap: '8px' }}>
          <span style={{ fontSize: '13px', fontWeight: 500 }}>
            {version.user_name}
            {version.user_type == 'Patient' && <span className='text-muted font-size-14'> (Patient)</span>}
          </span>
          <span style={{ fontSize: '12px', color: '#868e96' }}>
            <DateFormatView dateTime={version.created_at} />
          </span>
        </div>
        <div className="d-flex flex-wrap" style={{ gap: '6px' }}>
          <ChangedValuesDetails version={version} />
        </div>
      </>
    )
  }

  return (
    <div className={`dropdown show dropleft bg-transparent ${wrapperClasses}`}>
      <span id="UpdateHistoryTrack" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i className="las la-history cursor-pointer font-size-20"></i>
      </span>
      <div
        className="dropdown-menu p-4 overflow-auto"
        aria-labelledby="UpdateHistoryTrack"
        onClick={(e) => e.stopPropagation()}
        style={{ minWidth: '360px', maxWidth: '420px', maxHeight: '25rem' }}
      >
        <p className="text-muted mb-3" style={{ fontSize: '12px', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
          Update History
        </p>
        <div style={{ position: 'relative', paddingLeft: '20px' }}>
          <div style={{
            position: 'absolute',
            left: '6px',
            top: '8px',
            bottom: '8px',
            width: '1px',
            backgroundColor: '#dee2e6'
          }} />
          {version_attributes?.length === 0 ?
            <div className="text-muted py-4">
              No update history available
            </div> :
            version_attributes?.map((version, index) => (
              <div key={index} style={{ position: 'relative', marginBottom: '16px' }}>
                <div style={{
                  position: 'absolute',
                  left: '-17px',
                  top: '6px',
                  width: '10px',
                  height: '10px',
                  borderRadius: '50%',
                  backgroundColor: '#378ADD',
                  border: '2px solid #fff',
                  zIndex: 1
                }} />
                <div style={{
                  border: '1px solid #e9ecef',
                  borderRadius: '10px',
                  padding: '10px 14px',
                  backgroundColor: '#fff'
                }}>
                  <RenderVersionDetails version={version} />
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}
